export default __webpack_public_path__ + "static/media/budvue-logo.4230f0d3.png";